/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/common';
import { COMMON, USER } from '@/store/types';
import store from '@/store';
import { showToast } from '@/store/utils';
import { finalizeAction, StoreActionEnv, ActionType } from '@/store/actions';
import { getLocal, clearLocal, setLocal } from '@/utils/storage';

export interface StoreCommonStartState {
  start: api.StartData;
  uid: number;
  time: number;
}

export default {
  namespaced: true,
  state: {
    start: null,
    uid: null,
    time: null,
  },
  getters: {},
  actions: {
    [COMMON.GET_START](
      { commit, state, rootState }: StoreActionEnv<StoreCommonStartState>,
      { action: rawAction }: { action: ActionType } = { action: '' },
    ) {
      const action = finalizeAction(rawAction, state.time && state.uid === rootState.user.user.id);
      if (action) {
        return new Promise((resolve, reject) => {
          store.dispatch(`user/${USER.GET}`).then(() => {
            api.getStart().then((res) => {
              if (res.data.signTips) {
                showToast({
                  text: res.data.signTips,
                  time: 2500,
                  type: 'success',
                });
              }
              commit(COMMON.GET_START, {
                uid: rootState.user.user.id,
                data: res.data,
              });
              resolve(state.start);
            });
          }).catch(reject);
        });
      }
      return Promise.resolve(state.start);
    },
  },
  mutations: {
    [COMMON.GET_START](state: StoreCommonStartState, { uid, data }) {
      const apiVersion = getLocal('apiVersion');
      if (apiVersion !== data.apiVersion) {
        clearLocal();
        setLocal('apiVersion', data.apiVersion);
      }
      state.start = data;
      state.uid = uid;
      state.time = new Date().valueOf();
    },
  },
};
